import Directory from './Directory';
import Banner from './Banner';
import GalleryConfig from '../Configuration/GalleryConfig';
import GallerySection from './GallerySection';

export default class Gallery {
  protected configuration: GalleryConfig;

  constructor(protected dir: Directory) {
    this.configuration = dir.config().gallery();
  }

  public directory(): Directory {
    return this.dir;
  }

  public config(): GalleryConfig {
    return this.configuration;
  }

  public name(): string {
    return this.config().name();
  }

  public description(): string {
    return this.config().description();
  }

  public sections(): GallerySection[] {
    return this.config()
      .sections()
      .map(config => new GallerySection(config, this));
  }

  public banners(): Banner[] {
    return this.directory()
      .children()
      .filter(c => c.isBanner()) as Banner[];
  }
}
